import $x from '@/utils/$x';

/**
 * 导航菜单
 * @param {*} params
 * @returns
 */
export async function sysMenuNav(params) {
  return $x.post('/sys/menu/nav', params);
}

/**
 * 所有菜单列表
 * @param {*} params
 * @returns
 */
export async function sysMenuList(params) {
  return $x.post('/sys/menu/list', params);
}

/**
 * 选择菜单(添加、修改菜单)
 * @param {*} params
 * @returns
 */
export async function sysMenuSelect(params) {
  return $x.post('/sys/menu/select', params);
}

/**
 * 菜单信息
 * @param {*} params menuId
 * @returns
 */
export async function sysMenuInfo(params) {
  return $x.post('/sys/menu/info', params);
}

/**
 * 保存菜单
 * @param {*} params
 * @returns
 */
export async function sysMenuSave(params) {
  return $x.post('/sys/menu/save', params);
}

/**
 * 更新菜单
 * @param {*} params
 * @returns
 */
export async function sysMenuUpdate(params) {
  return $x.post('/sys/menu/update', params);
}

/**
 * 删除菜单
 * @param {*} params menuId
 * @returns
 */
export async function sysMenuDelete(params) {
  return $x.post('/sys/menu/delete', params);
}

/// 角色管理

/**
 * 角色列表
 * @param {*} params
 * @returns
 */
export async function sysRoleList(params) {
  return $x.post('/sys/role/list', params);
}

/**
 * 选择菜单(添加、修改菜单)
 * @param {*} params
 * @returns
 */
export async function sysRoleSelect(params) {
  return $x.post('/sys/role/select', params);
}

/**
 * 菜单信息
 * @param {*} params menuId
 * @returns
 */
export async function sysRoleInfo(params) {
  return $x.post('/sys/role/info', params);
}

/**
 * 角色菜单
 * @param {*} params
 * @returns
 */
export async function sysRoleSave(params) {
  return $x.post('/sys/role/save', params);
}

/**
 * 角色菜单
 * @param {*} params
 * @returns
 */
export async function sysRoleUpdate(params) {
  return $x.post('/sys/role/update', params);
}

/**
 * 角色菜单
 * @param {*} params menuId
 * @returns
 */
export async function sysRoleDelete(params) {
  return $x.post('/sys/role/delete', params);
}

/**
 * 设置角色
 * @param {*} params menuId
 * @returns
 */
export async function sysUserRoleSet(params) {
  return $x.post('/sys/user/set/role', params);
}

/**
 * 菜单
 * @param {*} params parentMenuCode
 * @returns
 */
export async function siteMenuList(params) {
  return $x.post('/enterprise/menu/list', params);
}
/**
 * 菜单详情
 * @param {*} params parentMenuCode
 * @returns
 */
export async function siteMenuGet(params) {
  return $x.post('/enterprise/menu/getMenu', params);
}
/**
 * 菜单保存或更新
 * @param {*} params parentMenuCode
 * @returns
 */
export async function siteMenuSaveOrUpdate(params) {
  return $x.post('/enterprise/menu/saveOrUpdateMenu', params);
}
/**
 * 菜单删除
 * @param {*} params parentMenuCode
 * @returns
 */
export async function siteMenuDelete(params) {
  return $x.post('/enterprise/menu/del', params);
}
/**
 * 路由搜索
 * @param {*} params parentMenuCode
 * @returns
 */
export async function siteRouteSearch(params) {
  return $x.post('/product/route/search', params);
}
